import React from 'react';
import { IProps, IState } from './types';
import _ from 'lodash';
// import moment from 'moment';
import moment from 'moment-timezone';
import service from 'bff/services/newListService';
import { ShareInfoContent, DataContent } from 'bff/models/new/newList';
import { RouterSettings } from 'constants/models/routerSettings';
import { NewsType, NewsSectionType } from 'constants/enums/newsType.enum';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import commonService from 'utils/commonService';
import storageService from 'utils/storageService';
import SliderMobile from 'components/SliderMobile';
import CardGrid from 'components/Card/CardGrid';

class NewsList extends React.Component<IProps, IState> {
  private sectionAnnouncementRef = React.createRef() as React.RefObject<HTMLDivElement>;
  private sectionArticleRef = React.createRef() as React.RefObject<HTMLDivElement>;
  private sectionVideoRef = React.createRef() as React.RefObject<HTMLDivElement>;
  private sectionReleaseRef = React.createRef() as React.RefObject<HTMLDivElement>;

  readonly state: IState = {
    activeTab: NewsType.All,
    tabFixed: false,
    section: {
      [NewsSectionType.Announcement]: {
        ref: this.sectionAnnouncementRef,
        route: RouterSettings.News.Announcement,
        loadedMore: false,
        initDataAmount: 3
      },
      [NewsSectionType.Article]: {
        ref: this.sectionArticleRef,
        route: RouterSettings.News.Article,
        loadedMore: false,
        initDataAmount: 3
      },
      [NewsSectionType.Video]: {
        ref: this.sectionVideoRef,
        route: RouterSettings.News.Video,
        loadedMore: false,
        initDataAmount: 3
      },
      [NewsSectionType.Release]: {
        ref: this.sectionReleaseRef,
        route: RouterSettings.News.Release,
        loadedMore: false,
        initDataAmount: 3
      }
    },
    newList: {
      SHARE_INFO: []
    }
  }

  async componentDidMount() {
    this.addWindowScrollEvent();

    const initSetting = await service.fetchInitSetting();
    this.setState(state => ({
      ...state,
      newList: {
        ...state.newList,
        SHARE_INFO: [...initSetting.newList.SHARE_INFO]
      }
    }));
  }

  componentDidUpdate() {
    if (storageService.getItem(storageKeys.TempInfo)) {
      this.handleSetTempState();
    }
    // console.log('state', this.state);
  }

  componentWillUnmount() {
    this.removeWindowScrollEvent();

    // 取得各 Section「載入更多」的狀態 (State)
    const sectionLoadedMore = {} as any;
    Object.keys(this.state.section).forEach((key) => {
      sectionLoadedMore[key] = _.pick(this.state.section[key as NewsSectionType], ['loadedMore']);
    });

    // 將頁面操作記錄存至 storage
    // (1. URL。 2. active tab。 3. 各 section loaded more 狀態。)
    storageService.setItem(storageKeys.TempInfo, JSON.stringify({ url: RouterSettings.News.List, activeTab: this.state.activeTab, section: sectionLoadedMore }));
  }

  /**
   * @description 新增 window scroll 事件監聽
   */
  addWindowScrollEvent = () => {
    window.addEventListener('scroll', this.setTabsFixed, false);
    window.addEventListener('scroll', this.handleSetTabActive, false);
  }

  /**
   * @description 移除 window scroll 事件監聽
   */
  removeWindowScrollEvent = () => {
    window.removeEventListener('scroll', this.setTabsFixed, false);
    window.removeEventListener('scroll', this.handleSetTabActive, false);
  }

  /**
   * @description 設回跳轉頁面前的位置資訊與展開頁面
   */
  handleSetTempState = () => {
    const tempInfo = JSON.parse(storageService.getItem(storageKeys.TempInfo));
    storageService.removeItem(storageKeys.TempInfo);

    if (tempInfo.url === RouterSettings.News.List) {
      // 設置 active tab
      this.handleSetTabsActive(tempInfo.activeTab, false);
      // 設置各 Section 「載入更多」狀態 (State)
      Object.keys(tempInfo.section).forEach((sectionKey) => {
        this.setState(state => ({
          ...state,
          section: {
            ...state.section,
            [sectionKey]: {
              ...state.section[sectionKey as NewsSectionType],
              loadedMore: tempInfo.section[sectionKey].loadedMore
            }
          }
        }));
      });
    } else {
      commonService.scrollToTop();
    }
  }

  /**
   * @description 視窗滾動至 Tabs 區塊時，Tabs 區塊設置 Fixed (Fixed 在 Header 下方)
   */
  setTabsFixed = () => {
    // [說明]: 使用 查詢回來的 最新消息列表資料，使用第一筆資料的 Section 的 Ref 取得區塊到頁面底部的距離，減去 Header 高度和 Tabs 高度。
    let { newList } = this.state;
    if (newList && newList.SHARE_INFO) {
      newList = {
        ...newList,
        SHARE_INFO: _.filter(newList.SHARE_INFO, (info) => Object.keys(info).length > 0)
      }
    }

    let sectionRef;
    if (newList && newList.SHARE_INFO && newList.SHARE_INFO.length > 0) {
      sectionRef = this.state.section[newList.SHARE_INFO[0].INFO_TYPE as NewsSectionType]?.ref;
    }

    if (sectionRef && sectionRef.current) {
      const headerHeight = document.getElementsByTagName('header')[0].clientHeight;
      const tabsHeight = document.getElementsByClassName('card-grid-list__tabs')[0].clientHeight;
      const tabsOffsetTop = (window.pageYOffset + sectionRef.current.getBoundingClientRect().top) - (headerHeight + tabsHeight);
      const scrollTopPosition = window.pageYOffset;

      this.setState(state => ({ ...state, tabFixed: (scrollTopPosition > tabsOffsetTop) }));
    }
  }

  /**
   * @description 依滾動高度設置上方 Tab 狀態
  */
  handleSetTabActive = () => {
    const refArrays = new Array(0);
    const announceRef = this.state.section[NewsSectionType.Announcement].ref;
    if (announceRef && announceRef.current) {
      refArrays.push({
        ref: announceRef,
        tab: NewsSectionType.Announcement
      });
    }
    const articleRef = this.state.section[NewsSectionType.Article].ref;
    if (articleRef && articleRef.current) {
      refArrays.push({
        ref: articleRef,
        tab: NewsSectionType.Article
      });
    }
    const videoRef = this.state.section[NewsSectionType.Video].ref;
    if (videoRef && videoRef.current) {
      refArrays.push({
        ref: videoRef,
        tab: NewsSectionType.Video
      });
    }
    const releaseRef = this.state.section[NewsSectionType.Release].ref;
    if (releaseRef && releaseRef.current) {
      refArrays.push({
        ref: releaseRef,
        tab: NewsSectionType.Release
      });
    }

    if (refArrays.length > 0) {
      const headerHeight = document.getElementsByTagName('header')[0].clientHeight;
      const tabFixedHeight = document.getElementsByClassName('card-grid-list__tabs-fix')[0].clientHeight;
      const scrollTopPosition = window.pageYOffset;

      const scrollPosition = (scrollTopPosition + headerHeight + tabFixedHeight);

      let activeTab = this.state.activeTab;

      for (let i = 0; i < refArrays.length; i += 1) {
        if (i === 0) {
          // 滾動高度低於 第一區塊
          if (scrollPosition < refArrays[i].ref.current.offsetTop && this.state.activeTab !== NewsType.All) {
            activeTab = NewsType.All;
          }
        }

        if (i + 1 < refArrays.length) {
          // 滾動高度界於 當前區塊 與 下一區塊
          if (scrollPosition >= refArrays[i].ref.current.offsetTop &&
            scrollPosition < refArrays[i + 1].ref.current.offsetTop &&
            this.state.activeTab !== refArrays[i].tab
          ) {
            activeTab = refArrays[i].tab;
          }
        }

        if (i === refArrays.length - 1) {
          // 滾動高度高於 最後區塊
          if (scrollPosition >= refArrays[i].ref.current.offsetTop &&
            this.state.activeTab !== refArrays[i].tab
          ) {
            activeTab = refArrays[i].tab;
          }
        }
      }

      // const newsSection = this.handleUpdateNewSection(activeTab);
      this.setState(state => ({
        ...state,
        activeTab: activeTab
        // section: { ...newsSection }
      }));
    }
  }

  /**
   * @description 設置 tab active
   * @param tabType Tab 類型
   */
  handleSetTabsActive = (tabType: string, applyAnimation: boolean = true) => {
    const newsSection = this.handleUpdateNewSection(tabType);
    // 設置 active tab state
    this.setState(state => ({
      ...state,
      activeTab: tabType,
      section: { ...newsSection }
    }));

    // 切換 Tab 視窗滾動至指定區塊
    if (tabType !== NewsType.All) {
      setTimeout(() => {
        const headerHeight = document.getElementsByTagName('header')[0].clientHeight;
        const tabFixedHeight = document.getElementsByClassName('card-grid-list__tabs-fix')[0].clientHeight;
        const sectionRef = this.state.section[tabType as NewsSectionType].ref;
        // (sectionRef && sectionRef.current) && window.scrollTo({ top: sectionRef.current.offsetTop - (headerHeight + tabFixedHeight), behavior: applyAnimation ? 'smooth' : 'auto' });
        (sectionRef && sectionRef.current) && window.scrollTo({ top: sectionRef.current.offsetTop + 10 - (headerHeight + tabFixedHeight) });
      });
    } else {
      // window.scroll({ top: 0, behavior: 'smooth' });
      window.scroll({ top: 0 });
    }
  }

  /**
   * @description 處理各 Section 載入更多
   * @param sectionKey 頁面 Section 的 Key 值
   */
  handleLoadMore = (sectionKey: string) => {
    const newsSection = this.handleUpdateNewSection(sectionKey);
    this.setState(state => ({
      ...state,
      section: { ...newsSection }
    }));
  }

  /**
   * @description 取得更新展開區塊後的列表資訊
  */
  handleUpdateNewSection = (sectionKey: string) => {
    const newsSection: any = { ...this.state.section };
    _.forEach(Object.keys(newsSection), (newsSectionKey: any) => {
      // 預設展開為 false
      newsSection[newsSectionKey].loadedMore = false;
      // 若為使用中的區塊，設定為 true
      if (newsSectionKey === sectionKey) {
        newsSection[newsSectionKey].loadedMore = true;
      }
    });

    return newsSection;
  }

  /**
   * @description 處理 Card 點擊後導頁
   * @param sn Share Info Data 的 SN 參數
   * @param infoType Share Info Data 的 INFO_TYPE 參數
   */
  handleCardGridClick = async (sn: number, infoType: string) => {
    const newInfos = await service.fetchArticle(sn);
    const route = this.state.section[infoType as NewsSectionType].route;

    if (newInfos) {
      storageService.setItem(storageKeys.NewsDetail, JSON.stringify(newInfos));
      this.props.history.push({ pathname: route, state: { newInfo: newInfos } });
    }
  }

  render() {
    return (
      <div className="news-list">
        <div className="card-grid-list">
          {/* Card Grid Header */}
          <div className="card-grid-list__header">
            <div className="card-grid-list__tabs">
              <div className={'card-grid-list__tabs-fix' + (this.state.tabFixed ? ' card-grid-list__tabs-fix--fixed' : '')}>
                <div className="card-grid-list__tabs-container">
                  <div className="card-grid-list__tabs-wrap">
                    <div
                      className={'card-grid-list__tab' + (this.state.activeTab === NewsType.All ? ' card-grid-list__tab--active' : '')}
                      onClick={() => this.handleSetTabsActive(NewsType.All)}
                    >
                      <span>全部</span>
                    </div>
                    {
                      this.state.newList.SHARE_INFO &&
                      this.state.newList.SHARE_INFO.length > 0 &&
                      this.state.newList.SHARE_INFO.map((shareInfo: ShareInfoContent, index: number) => {
                        if (Object.keys(shareInfo).length === 0) return null;

                        return (
                          <div
                            className={'card-grid-list__tab' + (this.state.activeTab === shareInfo.INFO_TYPE ? ' card-grid-list__tab--active' : '')}
                            key={index}
                            onClick={() => this.handleSetTabsActive(shareInfo.INFO_TYPE)}
                          >
                            <span>{shareInfo.INFO_NAME}</span>
                          </div>
                        );
                      })
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Card Grid Content */}
          <div className="card-grid-list__content">
            {
              this.state.newList.SHARE_INFO &&
              this.state.newList.SHARE_INFO.length > 0 &&
              this.state.newList.SHARE_INFO.map((shareInfo: ShareInfoContent, index: number) => {
                if (Object.keys(shareInfo).length === 0) return null;
                const sectionRef = this.state.section[shareInfo.INFO_TYPE as NewsSectionType].ref;
                const sectionLoadedMore = this.state.section[shareInfo.INFO_TYPE as NewsSectionType].loadedMore;
                const sectionInitDataAmount = this.state.section[shareInfo.INFO_TYPE as NewsSectionType].initDataAmount;
                const shareInfoDataDeep = _.cloneDeep(shareInfo.DATA);
                const shareInfoDataPc = !sectionLoadedMore ? [...shareInfoDataDeep].splice(0, sectionInitDataAmount) : [...shareInfoDataDeep];
                const shareInfoDataMobile = [...shareInfoDataDeep];
                return (
                  <div className="card-grid-list__section" key={index} ref={sectionRef}>
                    <div className="template-container">
                      <div className="template-content">
                        <div className="card-grid-list__section-title">{shareInfo.INFO_NAME}</div>
                        <div className="card-grid-list__section-content">
                          <div className="card-grid-list__pc">
                            <div className="card-grid-list__pc-section-content">
                              {shareInfoDataPc.map((data: DataContent, index: number) => (
                                <CardGrid
                                  key={index}
                                  imgUrl={data.IMAGE_URL}
                                  title={data.TITLE}
                                  period={moment(data.CREATE_TIME).format('YYYY/MM/DD')}
                                  desc={data.BRIEF}
                                  onClick={() => this.handleCardGridClick(data.SN, data.INFO_TYPE)}
                                />
                              ))}
                            </div>
                            {shareInfo.DATA.length > sectionInitDataAmount && !sectionLoadedMore && (
                              <div className="card-grid-list__pc-section-controls">
                                <button
                                  type="button"
                                  className="card-grid-list__more-btn"
                                  onClick={() => this.handleLoadMore(shareInfo.INFO_TYPE)}
                                >
                                  載入更多
                                 </button>
                              </div>
                            )}
                          </div>
                          <div className="card-grid-list__mobile">
                            <div className="card-grid-list__mobile-section-content">
                              {shareInfoDataMobile.length > 0 && (
                                <SliderMobile
                                  name={`news-list-${shareInfo.INFO_TYPE}-slider`}
                                  config={{ loop: true }}
                                >
                                  {shareInfoDataMobile.map((data: DataContent, index: number) => (
                                    <SliderMobile.Item key={index}>
                                      <CardGrid
                                        imgUrl={data.IMAGE_URL}
                                        title={data.TITLE}
                                        period={moment(data.CREATE_TIME).format('YYYY/MM/DD')}
                                        desc={data.BRIEF}
                                        onClick={() => this.handleCardGridClick(data.SN, data.INFO_TYPE)}
                                      />
                                    </SliderMobile.Item>
                                  ))}
                                </SliderMobile>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            }
          </div>
        </div>
      </div>
    );
  }
};

export default NewsList;
